import React from "react";
import { useLang } from "@/i18n";

export const CapacityMeter = ({ capacity, used, remaining }) => {
  const { t } = useLang();
  const pct = capacity > 0 ? Math.min(100, Math.round((used / capacity) * 100)) : 0;
  const over = used > capacity;
  const barColor = over ? "bg-destructive" : pct > 80 ? "bg-amber-500" : "bg-primary";
  return (
    <div data-testid="capacity-meter" className="space-y-1.5">
      <div className="flex items-center justify-between text-xs font-medium">
        <span className="text-muted-foreground">{t("capacity")}</span>
        <span className="font-mono">
          <span className={over ? "text-destructive font-bold" : "text-foreground"}>{used} kg</span>
          <span className="text-muted-foreground"> {t("of")} {capacity} kg</span>
        </span>
      </div>
      <div className="h-2.5 w-full rounded-full bg-secondary overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-700 ${barColor}`} style={{ width: `${pct}%` }} />
      </div>
      <div className="flex items-center justify-between text-xs">
        <span className="text-muted-foreground">{t("used")} {pct}%</span>
        <span className={`font-semibold ${remaining <= 0 ? "text-destructive" : "text-primary"}`}>
          {t("remaining")}: {remaining} kg
        </span>
      </div>
    </div>
  );
};
